import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useMutation } from "@tanstack/react-query";

const useMutationRejectLoanApplication = (options?: any) => {
  const { token } = useAuth();
  return useMutation({
    mutationKey: ["RejectLoanApplication"],
    mutationFn: ({ loanId }: { loanId: string }) =>
      fetchApi(`rejectLoanApplication?id=${loanId}`, token).get(),
  });
};

export default useMutationRejectLoanApplication;
